// Las listas se guardan completas: también se envían los vacíos que eliminan entradas.
export const indicesLista = (valores, columnas) => [...new Set(columnas
  .filter((c) => String(valores[c.k] ?? '').trim() !== '')
  .map((c) => c.indice))].sort((a, b) => a - b);

export const agregarEntrada = (indices) => {
  if (indices.length >= 10) return indices;
  const libre = Array.from({ length: 10 }, (_, i) => i).find((i) => !indices.includes(i));
  return [...indices, libre].sort((a, b) => a - b);
};

export const quitarEntrada = (valores, columnas, indice) => {
  const siguiente = { ...valores };
  columnas.filter((c) => c.indice === indice).forEach((c) => { siguiente[c.k] = ''; });
  return siguiente;
};

export const cambiosLista = (valores, columnas, indices) => columnas.map((c) => ({
  columna: Number(c.k), valor: indices.includes(c.indice) ? (valores[c.k] ?? '') : '',
}));
